import { withCancellation } from '../../utils/phases';

/* Conversion des lignes de la base (snake_case) vers les objets de l'application. */

export const mapBrick = (b) => ({
  id: b.id,
  nom: b.nom,
  joursVendus: b.jours_vendus,
  echeance: b.echeance,
  jira_epic: b.jira_epic,
  isJiraDefault: b.is_jira_default || false,
});

export const mapPhase = (ph, briques) =>
  withCancellation(
    {
      id: ph.id,
      nom: ph.nom,
      facturation: ph.facturation,
      dateDebut: ph.date_debut,
      ligneId: ph.affaire_ligne_id,
      lateHoursSeen: ph.heures_hors_fin_vues,
      jira_project_key: ph.jira_project_key,
      tjm: ph.tjm,
      joursTotal: ph.jours_total,
      montantGlobal: ph.montant_global,
      nbDevs: ph.nb_devs,
      dureeMois: ph.duree_mois,
      correctifQte: ph.correctif_qte,
      correctifUnite: ph.correctif_unite,
      evolutifQte: ph.evolutif_qte,
      evolutifUnite: ph.evolutif_unite,
      maintenanceReports: ph.maintenance_reports || {},
      seenAlerts: ph.alertes_vues || {},
      dateFinContrat: ph.date_fin_contrat,
      echeance: ph.echeance,
      briques,
    },
    ph.date_fin,
    ph.annulee_le || null,
  );

export const mapClient = (c, phases) => ({
  id: c.id,
  nom: c.nom,
  jira_project_key: c.jira_project_key,
  color: c.color || null,
  archivedAt: c.archived_at || null,
  phases,
});

export const mapAssignment = (a) => ({
  id: a.id,
  devId: a.dev_id,
  briqueId: a.brique_id,
  debut: a.debut,
  fin: a.fin,
  heuresParJour: a.heures_par_jour,
});

export const mapMember = (d) => ({
  id: d.dev_id || d.id,
  nom: d.nom,
  tauxContrat: d.taux_contrat || 100,
  coutHoraire: d.cout_horaire || 0,
  archived: !!d.archived_at,
  joursTravailles: d.jours_travailles || [],
  isPlanifiable: d.is_planifiable !== false,
  absences: [],
  color: d.color || null,
  soldeCp: d.solde_cp || 0,
  email: d.email || null,
  role: d.role || 'dev',
  typeContrat: d.type_contrat || 'CDI',
  createdAt: d.created_at || null,
  dateFinContrat: d.date_fin_contrat || '',
  isCongesValidator: !!d.is_conges_validator,
});

/* Regroupe des lignes par clé : { [clé]: [valeurs converties] }. */
export function groupBy(rows, key, map) {
  const groups = {};
  for (const r of rows || []) (groups[r[key]] ||= []).push(map(r));
  return groups;
}
